import { Button, Flex } from 'antd'
import { ReactNode } from 'react'
import { LeftOutlined } from '@ant-design/icons'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import Title from 'shared/components/typography/Title'
import { lang } from './lang'
import s from './s.module.css'

type Props = {
  showBackButton?: boolean
  onBackClick?: () => void
  title: ReactNode
  subtitle?: ReactNode
}

export default function Header({ title, subtitle, showBackButton, onBackClick }: Props) {
  return (
    <Flex vertical gap={4} align="flex-start">
      {showBackButton ? (
        <Button
          type="text"
          icon={<LeftOutlined color="var(--grey-300)" />}
          className={s.backButton}
          size="small"
          onClick={onBackClick}
        >
          <FormattedMessage {...lang.back} />
        </Button>
      ) : null}
      <Title level={2} fontType="header" fontSize={3}>
        {title}
      </Title>
      {subtitle ? <Text>{subtitle}</Text> : null}
    </Flex>
  )
}
